import React from 'react';

import SectionLayout from 'dpl/quiz/components/SectionLayout';
import { SECTION_CLASSES } from 'dpl/quiz/sections/components/Section';

export const SECTION_NAME = 'VerificationCodeSection';

export default function VerificationCodeSection(props) {
  return (
    <div className={SECTION_CLASSES}>
      <SectionLayout {...props} />
    </div>
  );
}
